
<mat-dialog-content class="map-content">
        <iframe [src]="iframeUrl"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton (click)="onClose()">Close</button>
</mat-dialog-actions>
